import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class ServicesList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {
		// Destructuring for cleaner code
		const { rootState, history, handleAfterSave, object } = this.props;
		const { locationSelected, locations, locationSelectedBinaryId } = rootState;
		const { selectedActualLocation, services, location, location_binary_id } = object;
		const firstActiveLocation = locations.find(loc => !loc.archived);
		return (
			<>
				<h4 style={{ fontWeight: 'bold' }}>Services</h4>
				<div className={'row'} id={'moduleCardsContainer'}>
					{/* Services Modules Section */}
					{selectedActualLocation[0]?.location_moduless && services && services.map((data, key) => {
						let pkey, binary_id, location, location_binary_id, account = null;
						let module = data.pkey;

						return (
							<ModuleCard
								parent={
									locationSelected
										? locationSelectedBinaryId
										: (
											location
												? location_binary_id
												: firstActiveLocation.binary_id
										) +
										"-" +
										(
											locationSelected
												? locationSelected
												: (location ? location : firstActiveLocation.pkey)
										)
								}
								modulePkey={pkey}
								moduleBinaryId={binary_id}
								binaryId={binary_id}
								account={account}
								module={module}
								moduleClass={'Service'}
								price={data.price}
								name={data.name ?? null}
								showName={true}
								type={data.description}
								borderStyle={'#dbdbdb'}
								isSubscribed={false}
								location={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								locationBinaryId={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : firstActiveLocation.binary_id)}
								locationSelected={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								history={history}
								handleAfterSave={handleAfterSave}
								key={data.id}
							/>
						);
					})}
				</div>
			</>
		);
	}
}

export default ServicesList;
